import { CtaButton } from './cta-button'
import { WorkspaceMockup } from './mockups/workspace-mockup'
import { MountainArt } from './mountain-art'
import { TruchetField } from './truchet-field'

/** Hero, oversized display headline over mountain line-art, app preview below. */
export const HeroSection = () => (
  <section className="relative overflow-hidden pt-[72px]" id="top">
    {/* Truchet arc field, masked to a hole behind the headline so the type
     * stays clean while the linework fills the hero's edges. */}
    <TruchetField
      className="absolute inset-0 h-full w-full text-[#0b0b0d] opacity-[0.05] [mask-image:radial-gradient(100%_80%_at_50%_32%,transparent_30%,#000_75%)]"
      seed="planno-hero"
    />
    <div className="relative mx-auto max-w-[1120px] px-6">
      {/* Headline block */}
      <div className="relative z-10 pt-20 pb-10 text-center">
        {/* Weight-contrast headline: SemiBold against ExtraLight in the
         * same line, the light half tracked tighter. */}
        <h1 className="mx-auto max-w-[980px] font-display text-[#0b0b0d] text-[clamp(44px,7vw,80px)] leading-[1.06] tracking-[-0.01em]">
          Do briefing à entrega das chaves,{' '}
          <span className="font-extralight tracking-[-0.03em]">reunido em um só lugar</span>
        </h1>
        <p className="mx-auto mt-7 max-w-[720px] text-[#7c7c82] text-[clamp(17px,2.4vw,22px)]">
          CRM, propostas, projetos, tarefas, sprints, visitas, obras, financeiro, contratos e IA. A
          ferramenta <strong className="font-semibold">profissional</strong> construída para a forma
          como escritórios de arquitetura realmente trabalham.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <CtaButton size="lg" to="/sign-up" variant="yellow">
            Começar grátis
          </CtaButton>
          <CtaButton href="#pricing" size="lg" variant="soft">
            Ver planos
          </CtaButton>
        </div>
        <p className="mt-6 text-[#a8a8ad] text-[12px]">
          Plano gratuito para até 2 pessoas · sem cartão de crédito
        </p>
      </div>

      {/* Mountain line-art sits behind the lower hero. */}
      <MountainArt
        className="pointer-events-none absolute inset-x-0 bottom-[-40px] -z-0 h-[340px] w-full"
        variant="range"
      />
    </div>

    {/* App preview, flush to the bottom edge of the hero. */}
    <div className="relative z-10 mx-auto mt-6 max-w-[1240px] px-6">
      <WorkspaceMockup />
    </div>
  </section>
)
